module.exports = __webpack_public_path__ + "static/img/baogao.1e20931b.png";